const EXTENSION_MIME_MAP = {
	csv: "text/csv",
	gif: "image/gif",
	heic: "image/heic",
	heif: "image/heif",
	jpeg: "image/jpeg",
	jpg: "image/jpeg",
	mov: "video/quicktime",
	mp4: "video/mp4",
	pdf: "application/pdf",
	png: "image/png",
	svg: "image/svg+xml",
	txt: "text/plain",
	webp: "image/webp",
};

const MIME_EXTENSION_MAP = {
	"application/pdf": "pdf",
	"image/gif": "gif",
	"image/heic": "heic",
	"image/heif": "heif",
	"image/jpeg": "jpg",
	"image/png": "png",
	"image/svg+xml": "svg",
	"image/webp": "webp",
	"text/csv": "csv",
	"text/plain": "txt",
	"video/mp4": "mp4",
	"video/quicktime": "mov",
};

const getFileNameExtension = (name = "") => {
	const parts = String(name).toLowerCase().split(".");
	return parts.length > 1 ? parts.pop() : "";
};

export const getMimeType = (file) => {
	const explicitMime = String(file?.type || "").toLowerCase();

	if (
		explicitMime &&
		explicitMime !== "application/octet-stream" &&
		explicitMime !== "binary/octet-stream"
	) {
		return explicitMime;
	}

	const extension = getFileNameExtension(file?.name);
	return EXTENSION_MIME_MAP[extension] || "application/octet-stream";
};

export const getFileExtension = (file) => {
	const extension = getFileNameExtension(file?.name);
	if (extension) {
		return extension;
	}

	const mime = getMimeType(file);
	return MIME_EXTENSION_MAP[mime] || "";
};

export const ensureFilePathExtension = (path, file) => {
	const normalizedPath = String(path || "");
	if (!normalizedPath) {
		return normalizedPath;
	}

	const lastSegment = normalizedPath.split("/").pop() || "";
	if (lastSegment.includes(".")) {
		return normalizedPath;
	}

	const extension = getFileExtension(file);
	return extension ? `${normalizedPath}.${extension}` : normalizedPath;
};
